import AP from "../legacy/global";
import { getApiUrl } from "../utils/get-api-url";

export const getLinks = async () => {
  const apiUrl = getApiUrl("pxprogram");
  const url = `${apiUrl}/programs/${ENV_INFO.programConfigID}/displaycontent/links?media=json`;

  const response = await fetch(url, {
    method: "GET",
    credentials: "include"
  });

  const { headers: resHeaders, statusText, ok } = response;
  const contentType = resHeaders.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    throw new Error(statusText || "Network request failed.");
  }
  if (!ok) throw new Error(result.message || statusText);

  const result = await response.json();
  return result;
};

export const addLink = async ({
  name,
  href,
  selectedTargets,
  sectionId,
  subsectionId
}) => {
  const agentLocationFilters =
    AP.config.appConfig.application.agentLocationFilters;
  const apiUrl = getApiUrl("pxprogram");
  const url = `${apiUrl}/programs/${ENV_INFO.programConfigID}/displaycontent/links`;

  const selectedTargetsValues = selectedTargets.map(
    key => agentLocationFilters[key]
  );

  const data = {
    sectionId,
    displayFilter: selectedTargetsValues.join(","),
    name,
    subsectionId,
    href
  };

  const response = await fetch(url, {
    method: "POST",
    body: new URLSearchParams(Object.entries(data)).toString(),
    headers: {
      Authorization: AP.getAuthString(),
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(text.message || statusText);
  return Promise.resolve();
};

export const editLink = async ({
  id,
  name,
  href,
  selectedTargets,
  sectionId,
  subsectionId
}) => {
  const agentLocationFilters =
    AP.config.appConfig.application.agentLocationFilters;
  const apiUrl = getApiUrl("pxprogram");
  const url = `${apiUrl}/programs/${ENV_INFO.programConfigID}/displaycontent/links/${id}`;

  const selectedTargetsValues = selectedTargets.map(
    key => agentLocationFilters[key]
  );

  const data = {
    sectionId,
    displayFilter: selectedTargetsValues.join(","),
    name,
    subsectionId,
    href
  };

  const response = await fetch(url, {
    method: "PUT",
    body: new URLSearchParams(Object.entries(data)).toString(),
    headers: {
      Authorization: AP.getAuthString(),
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(text.message || statusText);
  return Promise.resolve();
};

export const deleteLink = async id => {
  const apiUrl = getApiUrl("pxprogram");
  const url = `${apiUrl}/programs/${ENV_INFO.programConfigID}/displaycontent/links/${id}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      Authorization: AP.getAuthString()
    }
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(text.message || statusText);
  return Promise.resolve();
};

// Classic View Resources from pxProgram
export const getResources = async () => {
  const apiUrl = getApiUrl("pxprogram");
  const url = `${apiUrl}/programs/${ENV_INFO.programConfigID}/displaycontent/documents?media=json`;

  const response = await fetch(url, {
    method: "GET",
    credentials: "include"
  });

  const { headers: resHeaders, statusText, ok } = response;
  const contentType = resHeaders.get("content-type");

  if (!contentType || !contentType.includes("application/json")) {
    throw new Error(statusText || "Network request failed.");
  }
  if (!ok) throw new Error(result.message || statusText);

  const result = await response.json();
  return result;
};
